import { withInstall } from '@touchvue/utils'
import Pic from './src/Pic.vue'
import PicViewer from './src/PicViewer.vue'

export const ToPic = withInstall(Pic, [PicViewer])

export default ToPic

export * from './src/pic'
